import { z } from 'zod/v3';
import { transformNull } from '../../common/utils';
import { DataObjectVersionSchema } from './DataObjectVersionSchema';

export const IndicatorAlgorithmSchema = z.object({
  algorithmCode: z.string(),
  confidentialityRule: z.boolean(),
  dimension: z.string().nullable(),
  algorithmTargetSequenceNumber: z.number().int().nullable(),
});

export const IndicatorConfidentialityObjectSchema = z.object({
  isFictitious: transformNull(z.boolean(), false),
  isPublic: transformNull(z.boolean(), false),
  confidentialityDimension: z.string(),
});

export const DataObjectIndicatorSchema = z.object({
  dataObjectDescriptionVersionId: z.number(),
  dataObjectDescriptionCodeName: z.string(),
  dataObjectVersion: DataObjectVersionSchema,
  indicator: z.object({
    name: z.string(),
    code: z.string(),
  }),
  value: z.number(),
  confidentialityStatus: z.string(),
  indicatorStatus: z.string().nullable(),
  indicatorConfidentialityStatus: z.string().nullable(),
  algorithms: z.array(IndicatorAlgorithmSchema),
  confidentialityObjects: z.array(IndicatorConfidentialityObjectSchema),
});
